/* Ten Scents — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var cfg = window.TenScents || {};
  var routes = cfg.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', predictive_search_url: '/search/suggest', root_url: '/' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = $('[data-autofocus], button, a, input', d);
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); var id = opener.getAttribute('data-open'); id === 'SearchModal' ? openSearch() : openDrawer(id); return; }
    var closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); var c = closer.closest('.drawer, .search-modal'); c && c.classList.contains('search-modal') ? closeSearch() : closeDrawer(c); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var s = $('.search-modal.is-open'); if (s) return closeSearch();
    $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Localization (currency / region) ---------- */
  $$('[data-localization] select').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Hero campaigns ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero);
    if (slides.length < 2) return;
    var i = 0, timer = null, speed = (parseInt(hero.getAttribute('data-speed'), 10) || 7) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      dots[i] && dots[i].setAttribute('aria-current', 'false');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden', 'false');
      dots[i] && dots[i].setAttribute('aria-current', 'true');
    }
    function play() { if (!reduce && hero.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { go(i + 1); }, speed); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { clearInterval(timer); go(n); }); });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', play);
    play();
  });

  /* ---------- Hero video ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  $$('[data-hero-video]').forEach(function (video) {
    var phone = window.matchMedia('(max-width: 749px)');
    var btn = $('[data-hero-pause]', video.parentNode);
    var userPaused = false;
    function pick() {
      // MP4 (H.264) plays almost everywhere; WebM covers browsers built without H.264.
      var h264 = video.canPlayType('video/mp4; codecs="avc1.640028"');
      var webm = phone.matches ? video.getAttribute('data-webm-phone') : video.getAttribute('data-webm');
      var src = phone.matches ? video.getAttribute('data-src-phone') : video.getAttribute('data-src');
      if (!h264 && webm && video.canPlayType('video/webm; codecs="vp9"')) src = webm;
      if (phone.matches && video.getAttribute('data-poster-phone')) video.poster = video.getAttribute('data-poster-phone');
      if (video.getAttribute('src') !== src) { video.src = src; if (!userPaused && !reduceMotion.matches) play(); }
    }
    function setBtn(paused) {
      if (!btn) return;
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? cfg.strings.playVideo : cfg.strings.pauseVideo);
    }
    function play() { var pr = video.play(); if (pr && pr.catch) pr.catch(function () { setBtn(true); }); setBtn(false); }
    pick();
    if (phone.addEventListener) phone.addEventListener('change', pick);
    if (reduceMotion.matches) { setBtn(true); } else { play(); }
    if (btn) btn.addEventListener('click', function () {
      if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); setBtn(true); }
      video._userPaused = userPaused;
    });
    // Pause while off screen to save battery and data
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          video._offscreen = !en.isIntersecting;
          if (en.isIntersecting) { if (!userPaused && !reduceMotion.matches && video.paused) play(); }
          else if (!video.paused) { video.pause(); }
        });
      }, { threshold: 0.15 }).observe(video);
    }
  });

  /* ---------- Motion: hero headline intro ---------- */
  var motion = document.documentElement.classList.contains('motion') && !reduceMotion.matches;
  if (motion) {
    $$('[data-hero-intro] h1, [data-hero-intro] h2').forEach(function (h) {
      var n = 0;
      (function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var outer = document.createElement('span'); outer.className = 'hero__word';
              var inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--w', n++);
              outer.appendChild(inner); frag.appendChild(outer);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1) { wrap(child); }
        });
      })(h);
      h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
    });
  } else {
    document.documentElement.classList.remove('motion');
  }

  /* ---------- Motion: headline loops with the film ---------- */
  // Just before the film restarts, the headline words lift away; as it begins again they rise back in.
  // If the film cannot play (blocked or still loading), the same cycle runs on a clock.
  // The pause button stops both. Text and buttons below the headline stay still so they can be read and used.
  if (motion) {
    $$('[data-hero-video]').forEach(function (video) {
      var slide = video.closest('.hero__slide');
      var h = slide && $('[data-hero-intro] h1, [data-hero-intro] h2', slide);
      if (!h) return;
      var CYCLE = 7.04, OUT = 0.95, last = 0, out = false, clock = performance.now();
      function leave() { if (!out) { h.classList.add('is-out'); out = true; } }
      function enter() { if (out) { h.classList.remove('is-out'); out = false; } }
      (function tick(now) {
        var stopped = video._userPaused || video._offscreen || !slide.classList.contains('is-active');
        if (stopped) { enter(); clock = now; }
        else if (!video.paused && video.duration) {
          var t = video.currentTime, d = video.duration;
          if (t + 0.5 < last) enter();             // the film looped
          else if (t > d - OUT) leave();
          last = t; clock = now;
        } else {
          var c = ((now - clock) / 1000) % CYCLE;   // film not playing: keep time ourselves
          if (c > CYCLE - OUT) leave(); else if (c < 0.2) enter();
        }
        requestAnimationFrame(tick);
      })(performance.now());
    });
  }

  /* ---------- Motion: reveal content as it scrolls into view ---------- */
  function setupReveals(root) {
    if (!motion || !('IntersectionObserver' in window)) return;
    var groups = [
      ['.section-head', false], ['.chips', false], ['.grid', true], ['.steps', true], ['.tiers', true],
      ['.page-links', true], ['.story > *', false], ['.order-cta > *', true], ['.newsletter > *', true]
    ];
    var targets = [];
    groups.forEach(function (g) {
      $$(g[0], root).forEach(function (el) {
        var items = g[1] ? Array.prototype.slice.call(el.children) : [el];
        items.forEach(function (item, i) {
          if (item.classList.contains('reveal') || item.closest('[data-hero]')) return;
          var r = item.getBoundingClientRect();
          // Content already on screen (or hidden) stays put; only what is below the fold eases in.
          if (r.height === 0 || r.top < window.innerHeight * 0.92) return;
          item.classList.add('reveal'); item.style.setProperty('--i', g[1] ? i % 4 : 0);
          targets.push(item);
        });
      });
    });
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { io.observe(t); });
  }
  window.TenScentsReveal = setupReveals;
  if (document.readyState === 'complete') setupReveals(document); else window.addEventListener('load', function () { setupReveals(document); });

  /* ---------- Scent family filter chips ---------- */
  $$('[data-filter-group]').forEach(function (group) {
    var scope = document.getElementById(group.getAttribute('data-filter-group'));
    if (!scope) return;
    var empty = $('[data-filter-empty]', scope.parentNode);
    $$('.chip', group).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('.chip', group).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        var want = chip.getAttribute('data-family');
        var shown = 0;
        $$('[data-family]', scope).forEach(function (card) {
          var ok = want === 'all' || card.getAttribute('data-family') === want;
          card.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = !count; });
  }
  function refreshCartDrawer(open) {
    return fetch(routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('#CartDrawerInner', html), current = $('#CartDrawerInner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var c = fresh ? fresh.getAttribute('data-count') : null;
        if (c !== null) updateCount(parseInt(c, 10));
        if (open) openDrawer('CartDrawer');
      });
  }
  function addToCart(id, qty, btn, sellingPlan) {
    if (btn) btn.classList.add('is-loading');
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [sellingPlan ? { id: id, quantity: qty || 1, selling_plan: sellingPlan } : { id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (cfg.cartType === 'page') { window.location = routes.cart_url; return; }
        return refreshCartDrawer(true);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || cfg.strings.addError); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(key, qty) {
    var inner = $('#CartDrawerInner'); inner && inner.classList.add('is-loading');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      if ($('[data-cart-page]')) { window.location.reload(); return; }
      return refreshCartDrawer(false);
    }).finally(function () { inner && inner.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var plan = form.querySelector('[name="selling_plan"]:checked');
    addToCart(id, qtyEl ? parseInt(qtyEl.value, 10) : 1, form.querySelector('[type="submit"]'), plan && plan.value ? plan.value : null);
  });
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart(quick.getAttribute('data-quick-add'), 1, quick); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var line = step.closest('[data-line-key]');
      var input = $('input', line);
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10));
      changeLine(line.getAttribute('data-line-key'), next);
      return;
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-key] input[type="number"]');
    if (input) changeLine(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Product page: size selector ---------- */
  $$('[data-product]').forEach(function (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var idInput = $('[name="id"]', root);
    var priceEl = $('[data-price]', root);
    var submit = $('[data-add-btn]', root);
    var wa = $('[data-wa-order]', root);
    var oils = $$('.bottle', root);
    $$('input[data-size]', root).forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = data.variants.filter(function (x) { return String(x.id) === radio.value; })[0];
        if (!v) return;
        idInput.value = v.id;
        priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price) + '</s>' : '');
        if (submit) {
          submit.disabled = !v.available;
          submit.querySelector('span').textContent = v.available ? cfg.strings.addToCart : cfg.strings.soldOut;
        }
        oils.forEach(function (b) { b.style.setProperty('--fill', radio.getAttribute('data-fill')); });
        $$('[data-unit-price-for]', root).forEach(function (u) { u.hidden = u.getAttribute('data-unit-price-for') !== String(v.id); });
        if (root._showVariantMedia) root._showVariantMedia(v);
        if (wa) {
          var msg = cfg.strings.waProduct.replace('[product]', data.title).replace('[size]', v.title);
          wa.href = 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(msg);
        }
        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) {}
      });
    });
    function showMedia(t) {
      var stage = $('.product__stage img', root);
      if (stage && t) { stage.src = t.getAttribute('data-src'); stage.srcset = ''; stage.alt = t.getAttribute('data-alt') || stage.alt; stage.classList.toggle('is-wide', t.getAttribute('data-wide') === 'true'); }
      $$('[data-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    }
    $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });
    // When a size is chosen, switch to the photo assigned to that size in Shopify (Variants > image)
    root._showVariantMedia = function (v) {
      var id = v.featured_media && v.featured_media.id;
      var t = id && $('[data-thumb][data-media-id="' + id + '"]', root);
      if (t) { showMedia(t); return; }
      var stage = $('.product__stage img', root);
      var src = v.featured_image && v.featured_image.src;
      if (stage && src) { stage.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400'; stage.srcset = ''; if (v.featured_image.alt) stage.alt = v.featured_image.alt; }
    };
  });

  /* ---------- Delivery estimator (Shopify shipping rates API) ---------- */
  // Rates come from Settings > Shipping and delivery: carrier-calculated, flat and local delivery by distance.
  var EKEY = 'tenscents:delivery-address';
  function estimatorInit(root) {
    $$('[data-estimator-form]', root).forEach(function (form) {
      if (form._ready) return; form._ready = true;
      var country = $('select[name="country"]', form), province = $('select[name="province"]', form);
      var provField = $('[data-province-field]', form), zip = $('input[name="zip"]', form);
      var saved = {}; try { saved = JSON.parse(localStorage.getItem(EKEY)) || {}; } catch (e) {}
      var want = saved.country || country.getAttribute('data-default');
      if (want) Array.prototype.forEach.call(country.options, function (o) { if (o.value === want || o.text === want) country.value = o.value; });
      function fillProvinces(selected) {
        var opt = country.options[country.selectedIndex], list = [];
        try { list = JSON.parse(opt && opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
        province.innerHTML = list.map(function (p) { return '<option value="' + p[0] + '">' + p[1] + '</option>'; }).join('');
        provField.hidden = !list.length;
        if (selected) province.value = selected;
      }
      fillProvinces(saved.province);
      if (saved.zip) zip.value = saved.zip;
      country.addEventListener('change', function () { fillProvinces(); });
    });
  }
  function rateLine(r) {
    var price = parseFloat(r.price) === 0 ? cfg.strings.estFree : formatMoney(Math.round(parseFloat(r.price) * 100));
    var when = '';
    if (r.delivery_range && r.delivery_range.length === 2) when = cfg.strings.estDays.replace('[min]', r.delivery_range[0]).replace('[max]', r.delivery_range[1]);
    else if (r.delivery_days && r.delivery_days.length) when = cfg.strings.estDay.replace('[days]', r.delivery_days.join('–'));
    var name = (r.presentment_name || r.name || '').replace(/</g, '&lt;');
    return '<li><span class="estimator__name">' + name + (when ? '<small>' + when + '</small>' : '') + '</span><span class="estimator__price">' + price + '</span></li>';
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-estimator-form]');
    if (!form) return;
    e.preventDefault();
    var out = $('[data-estimator-results]', form), btn = $('button[type="submit"]', form);
    var country = $('select[name="country"]', form).value, prov = $('select[name="province"]', form).value, zip = $('input[name="zip"]', form).value.trim();
    try { localStorage.setItem(EKEY, JSON.stringify({ country: country, province: prov, zip: zip })); } catch (err) {}
    var q = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=' + encodeURIComponent(country) + '&shipping_address[province]=' + encodeURIComponent(prov);
    var base = routes.cart_url.replace(/\/$/, '');
    out.innerHTML = '<p class="estimator__status">' + cfg.strings.estLoading + '</p>'; btn.disabled = true;
    function show(rates) {
      btn.disabled = false;
      var place = [zip, $('select[name="province"]', form).selectedOptions[0] && !$('[data-province-field]', form).hidden ? $('select[name="province"]', form).selectedOptions[0].text : '', $('select[name="country"]', form).selectedOptions[0].text].filter(Boolean).join(', ');
      if (!rates || !rates.length) { out.innerHTML = '<p class="estimator__status">' + cfg.strings.estNone + '</p>'; return; }
      var head = (rates.length === 1 ? cfg.strings.estOne : cfg.strings.estMany.replace('[count]', rates.length)).replace('[address]', place.replace(/</g, '&lt;'));
      out.innerHTML = '<p class="estimator__status">' + head + '</p><ul class="estimator__list">' + rates.map(rateLine).join('') + '</ul>';
    }
    function fail(errJson) {
      btn.disabled = false;
      var msg = cfg.strings.estError;
      if (errJson && typeof errJson === 'object') {
        var parts = []; Object.keys(errJson).forEach(function (k) { [].concat(errJson[k]).forEach(function (m) { parts.push((k === 'zip' ? 'Postal code' : k.charAt(0).toUpperCase() + k.slice(1)) + ' ' + m); }); });
        if (parts.length) msg = parts.join('. ') + '.';
      }
      out.innerHTML = '<p class="estimator__status estimator__status--error" role="alert">' + msg.replace(/</g, '&lt;') + '</p>';
    }
    fetch(base + '/prepare_shipping_rates.json?' + q, { method: 'POST' })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return poll(0); })
      .catch(fail);
    function poll(n) {
      return fetch(base + '/async_shipping_rates.json?' + q).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          if (j && j.shipping_rates) { show(j.shipping_rates); return; }
          if (n > 12) { fail(); return; }
          return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return poll(n + 1); });
        });
    }
  });
  estimatorInit(document);
  document.addEventListener('toggle', function (e) { if (e.target.matches && e.target.matches('[data-estimator]')) estimatorInit(e.target); }, true);

  /* ---------- Contact form: sales inquiry details ---------- */
  $$('[data-contact-form]').forEach(function (form) {
    var inquiry = $('[data-inquiry]', form), orderField = $('[data-order-field]', form);
    var scent = $('#ContactScent', form), phone = $('#ContactPhone', form), err = $('[data-contact-error]', form);
    function syncOrder() { if (orderField) orderField.hidden = !/order or delivery/i.test(inquiry.value); }
    if (inquiry) { inquiry.addEventListener('change', syncOrder); syncOrder(); }
    // Preselect a scent when arriving from "Ask about this scent" on a product page
    try {
      var want = new URLSearchParams(window.location.search).get('scent');
      if (want && scent) Array.prototype.forEach.call(scent.options, function (o) { if (o.value === want) scent.value = want; });
      if (want && inquiry && !inquiry.value) Array.prototype.forEach.call(inquiry.options, function (o) { if (!inquiry.value && /scent/i.test(o.value)) inquiry.value = o.value; });
    } catch (e) {}
    form.addEventListener('submit', function (e) {
      var how = $('input[name="contact[Preferred reply]"]:checked', form);
      if (how && how.value !== 'Email' && phone && !phone.value.trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        err.textContent = cfg.strings.phoneNeeded; err.hidden = false; phone.focus();
      } else if (err) { err.hidden = true; }
    });
    var done = $('[data-contact-success]', form); if (done) done.focus();
  });

  /* ---------- Wishlist (stored in this browser) ---------- */
  var WKEY = 'tenscents:wishlist';
  function readWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function writeWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} }
  function paintWish() {
    var list = readWish();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? cfg.strings.wishRemove : cfg.strings.wishAdd) + ' ' + (b.getAttribute('data-title') || ''));
    });
    $$('[data-wish-count]').forEach(function (b) { b.textContent = list.length; b.hidden = !list.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), list = readWish(), at = list.indexOf(h);
    if (at > -1) { list.splice(at, 1); toast(cfg.strings.wishRemoved); } else { list.push(h); toast(cfg.strings.wishAdded); }
    writeWish(list); paintWish(); renderWishPage();
  });
  function renderWishPage() {
    var mount = $('[data-wishlist-page]');
    if (!mount) return;
    var list = readWish();
    var empty = $('[data-wishlist-empty]');
    if (!list.length) { mount.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch(routes.root_url.replace(/\/$/, '') + '/products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; });
    })).then(function (cards) { mount.innerHTML = cards.join(''); paintWish(); });
  }
  paintWish(); renderWishPage();

  /* ---------- Predictive search ---------- */
  var modal = $('#SearchModal');
  function openSearch() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open'); document.body.classList.add('is-locked');
    setTimeout(function () { $('input', modal).focus(); }, 30);
  }
  function closeSearch() {
    modal.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  if (modal) {
    var input = $('input[name="q"]', modal), out = $('[data-search-results]', modal), t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var items = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<li class="muted" style="padding:16px 0">' + cfg.strings.noResults.replace('[q]', q.replace(/</g, '&lt;')) + '</li>'; return; }
            out.innerHTML = items.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '&width=120" alt="" loading="lazy">' : '<span class="ph"></span>';
              return '<li><a href="' + p.url + '">' + img + '<strong>' + p.title + '</strong><span class="price">' + formatMoney(Math.round(parseFloat(p.price_min || p.price) * 100)) + '</span></a></li>';
            }).join('');
          }).catch(function () { out.innerHTML = ''; });
      }, 180);
    });
  }

  /* ---------- Newsletter / contact feedback is server-rendered ---------- */

  /* ---------- Ambience audio (optional) ---------- */
  var amb = $('[data-ambience]');
  if (amb) {
    var audio = new Audio(amb.getAttribute('data-ambience'));
    audio.loop = true; audio.volume = 0.35;
    amb.addEventListener('click', function () {
      var on = amb.getAttribute('aria-pressed') === 'true';
      if (on) { audio.pause(); } else { audio.play().catch(function () {}); }
      amb.setAttribute('aria-pressed', on ? 'false' : 'true');
      $('span', amb).textContent = on ? cfg.strings.ambiencePlay : cfg.strings.ambiencePause;
    });
  }
})();
